// Actions
export const ADD_COLLECTION = 'companyExperience/entities/candidateAvailabilities/ADD_COLLECTION'
export const ADD_ITEM = 'companyExperience/entities/candidateAvailabilities/ADD_ITEM'

// Action Creators
export const addCollection = collection => ({
  type: ADD_COLLECTION,
  payload: collection.map(item => addItem(item.id, item)),
})

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_COLLECTION:
      return {
        ...state,
        ...payload.reduce((map, item) => {
          map[item.meta.id] = entity(state[item.meta.id], { type: item.type, payload: item.payload })
          return map
        }, {}),
      }

    case ADD_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getCandidateAvailabilityMap = state => state.entities.candidateAvailabilities || defaultMap
export const getCandidateAvailabilityItem = (state, id) => state.entities.candidateAvailabilities[id] || defaultEntity
